export const MEMBER_ACCESS_TOKEN = 'memberAccessToken';
export const REFERRAL_CODE = 'referralCode';
export const EXPIDATE_CODE = 'expediteCode';
export const PROMO_CODE = 'promoCode';
export const SUBSCRIPTION_ID = 'subscriptionId';
export const PRICE_ID = 'priceId';
export const TAG = 'tag';
